import { Col, Input, Row } from "reactstrap"
import BackButton from "../../../../components/common/BackButton/BackButton"
import styles from "./ContactUs.module.scss"
import { IoMdMail } from "react-icons/io"
import { FaPhone } from "react-icons/fa6"
import { MdFeedback } from "react-icons/md"
import Address from "../../../../assets/images/UserPortal/address.svg"
import Telephone from "../../../../assets/images/UserPortal/telephone.svg"
import Mail from "../../../../assets/images/UserPortal/gmail.svg"
import Whatsapp from "../../../../assets/images/UserPortal/whatsapp.svg"
import PrimaryButton from "../../../../components/common/PrimaryButton/PrimaryButton"

const ContactUs = () => {
  return (
    <div>
      <BackButton />
      <div className="m-3 m-md-5">
        <div className="d-flex justify-content-center mb-3">
          <div className={styles["heading"]}>CONTACT US</div>
        </div>

        <section>
          <div className={styles["info-wrapper"]}>
            <Row noGutters className="flex-column flex-md-row">
              <Col xs="1" className={styles.icon}>
                <IoMdMail className={styles['icon-sm']} />
              </Col>
              <Col>
                <div className={`${styles['info']} mt-2 mt-md-0`}>
                  We love to hear from our customers. You can contact to us via email. We will respond back to you as quickly as possible. Or you can also call
                  us at anytime from anywhere, we are available for 24/7.
                </div>
              </Col>
            </Row>
          </div>
          <div className={styles["info-wrapper"]}>
            <Row noGutters className="flex-column flex-md-row">
              <Col xs="1" className={styles.icon}>
                <FaPhone className={styles['icon-sm']} />
              </Col>
              <Col>
                <div className={`${styles['info']} mt-2 mt-md-0`}>
                  Our Experienced Customer Support Representatives will be taking your phone call and assist you for any of your concerns or queries!
                </div>
              </Col>
            </Row>
          </div>
          <div className={styles["info-wrapper"]}>
            <Row noGutters className="flex-column flex-md-row">
              <Col xs="1" className={styles.icon}>
                <MdFeedback className={styles['icon-sm']} />
              </Col>
              <Col>
                <div className={`${styles['info']} mt-2 mt-md-0`}>
                  You can also tell us about the website and what you think can be done to make it better. We are providing customers friendly services and also
                  connecting people with the world of Online Shopping. Your Comments and suggestions are of great value to us.
                </div>
              </Col>
            </Row>
          </div>
        </section>

        <div className={styles["contact-form"]}>
          <div className={styles["form-group"]}>
            <label htmlFor="name">Your Name</label>
            <Input name="name" id="name" placeholder="Full name" />
          </div>
          <div className={styles["form-group"]}>
            <label htmlFor="email">Email address</label>
            <Input name="email" id="email" placeholder="Email" />
          </div>
          <div className={styles["form-group"]}>
            <label htmlFor="phoneNo">Phone number</label>
            <Input name="phoneNo" type="number" id="phoneNo" placeholder="Phone" />
          </div>
          <div className={styles["form-group"]}>
            <label htmlFor="subject">Subject</label>
            <Input name="subject" id="subject" placeholder="Subject" />
          </div>
          <div className={`${styles["form-group"]} ${styles["form-group--full-width"]}`}>
            <label htmlFor="enquiry">Enquiry</label>
            <Input type="textarea" name="enquiry" id="enquiry" placeholder="Details" />
          </div>

          <div className={styles["address-info"]}>
            <Row noGutters>
              <Col xs="3" className="d-flex align-items-center justify-content-center">
                <img src={Address} alt="" className={styles["address-info-image"]} />
              </Col>
              <Col xs='9' className={`d-flex justify-content-center flex-column ${styles['info']}`}>
                <div className="fw-bold">ADDRESS</div>
                <div className="fw-semibold">Kohinoor town, Faisalabad</div>
              </Col>
            </Row>
            <Row noGutters>
              <Col xs="3" className="d-flex align-items-center justify-content-center">
                <img src={Telephone} alt="" className={styles["address-info-image"]} />
              </Col>
              <Col xs='9' className={`d-flex justify-content-center flex-column ${styles['info']}`}>
                <div className="fw-bold">PHONE NO</div>
                <div className="fw-semibold">03-111-222-333</div>
              </Col>
            </Row>
            <Row noGutters>
              <Col xs="3" className="d-flex align-items-center justify-content-center">
                <img src={Mail} alt="" className={styles["address-info-image"]} />
              </Col>
              <Col xs='9' className={`d-flex justify-content-center flex-column ${styles['info']}`}>
                <div className="fw-bold">EMAIL</div>
                <div className="fw-semibold">Loremipsum@gmail.com</div>
              </Col>
            </Row>
            <Row noGutters>
              <Col xs="3" className="d-flex align-items-center justify-content-center">
                <img src={Whatsapp} alt="" className={styles["address-info-image"]} />
              </Col>
              <Col xs='9' className={`d-flex justify-content-center flex-column ${styles['info']}`}>
                <div className="fw-bold">WATTSAPP</div>
                <div className="fw-semibold" v>
                  03123456789
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="mt-3">
          <PrimaryButton name={"Submit"} />
        </div>
      </div>
    </div>
  )
}

export default ContactUs
